import { language } from '@tencent/ppd-base-libs';
/**
 * 批量将字符串数组转成对象
 * @param config
 * @returns
 */
export function batchArrStrToObj({ config, configKey }) {
    for (const [key, value] of Object.entries(config)) {
        // 如果是对象
        if (Object.prototype.toString.call(value) === '[object Object]') {
            config[key] = batchArrStrToObj({ config: value, configKey });
        }
        else {
            if (configKey.includes(key)) {
                // @ts-ignore
                config[key] = getArrayFirstItemAsObj(getArrFromStr(value));
            }
        }
    }
    return config;
}
/** parse字符串 */
export const getArrFromStr = (str) => JSON.parse(str || '[]');
/** 兼容配置系统： 把数组的第一项作为对象返回 */
export const getArrayFirstItemAsObj = (arr) => (arr === null || arr === void 0 ? void 0 : arr[0]) || {};
/** 批量根据语言环境处理对象/数组 */
export const getConfigWithLang = ({ configKey, originalObj }) => {
    const lang = language.getLanguage();
    const resObj = {};
    if (Array.isArray(originalObj)) {
        return originalObj.map((item) => {
            if (Array.isArray(item) || Object.prototype.toString.call(item) === '[object Object]') {
                return getConfigWithLang({ configKey, originalObj: item });
            }
            return item;
        });
    }
    for (const [key, value] of Object.entries(originalObj)) {
        if (configKey.includes(key)) {
            resObj[key] = lang === 'en' ? originalObj[`${key}En`] : value;
        }
        else if (Array.isArray(value)) {
            resObj[key] = getConfigWithLang({ configKey, originalObj: value });
        }
        else if (Object.prototype.toString.call(value) === '[object Object]') {
            resObj[key] = getConfigWithLang({ configKey, originalObj: value });
        }
        else if (!configKey.includes(key.replace(/(.*)En/, '$1'))) {
            resObj[key] = value;
        }
    }
    return resObj;
};
/**
 * 根据某一字段作为外键关联两个数组，类似sql中left join
 * @param arrayA 目标数组（左表）
 * @param arrayB 关联数组（右表）
 * @param keyA 主键字段-左表
 * @param keyB 主键字段-右表
 * @returns 关联合并后的数组
 */
export const leftJoin = (arrayA, arrayB, keyA, keyB, isDeleteKeyB) => (arrayA || []).map((targetItem) => {
    const targetJoinItem = (arrayB || []).find(joinItem => joinItem[keyB] === targetItem[keyA]);
    // 有些情况，keyB 只是用来做关联的，不需要在列表中返回
    if (isDeleteKeyB && targetJoinItem)
        delete targetJoinItem[keyB];
    return Object.assign(Object.assign({}, targetItem), targetJoinItem);
});
